/**
 * @function read
 * @since 1.0.0
 */
export function read(file) {
    const promise = new Promise((success, failure) => {
        function onSuccess() {
            success(reader.result);
        }
        function onFailure() {
            failure();
        }
        const reader = new FileReader();
        reader.addEventListener('load', onSuccess);
        reader.addEventListener('error', onFailure);
        reader.readAsDataURL(file);
    });
    return promise;
}
